module.exports = __webpack_public_path__ + "static/media/C_J.e62478e0.png";